import React from 'react';
import '../styles/mission.css';

function Quote() {
  return (
    <section id="quote-561">
      <div className="cs-container">
        <div className="cs-content">
          <span className="cs-topper">Our Mission</span>
          <p className="cs-quote">
            In the corridors of finance, Morgan Bank isn't just a beacon of prosperity, it's a promise for tomorrow. Rooted in a commitment
            to both people and planet, it doesn't just shape wealth, but shapes a future where prosperity and sustainability walk hand in
            hand.{' '}
          </p>
          <span className="cs-name">MB Founders</span>
        </div>
      </div>
    </section>
  );
}

export default Quote;
